
import { NoseurObject } from "@rivtn/noseur";
import { HeraBaseService } from "./HeraBaseService";
import { ISupportRequest, ISupportRequestParticipant } from "./SupportRequestService";

export enum CommentStatus {
    ACTIVE = "ACTIVE",
    DELETED = "DELETED",
}

export enum AttachmentType {
    IMAGE = "IMAGE",
    AUDIO = "AUDIO",
    VIDEO = "VIDEO",
    UNKNOWN = "UNKNOWN",
}

export interface IAttachment {
    name: string;
    size: string;
    location: string;
    type: AttachmentType;
}

export interface ISupportRequestComment {
    comment: string;
    user_id: string;
    user_type: string;
    created_at: string;
    updated_at: string;
    external_id: string;
    status: CommentStatus;
    attachments: IAttachment[];
    user: ISupportRequestParticipant;
    support_request: ISupportRequest;
}

export class SupportRequestCommentService extends HeraBaseService {

    protected static instance: SupportRequestCommentService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportRequestCommentService.instance) SupportRequestCommentService.instance = new SupportRequestCommentService();
        return SupportRequestCommentService.instance;
    }

    querySupportRequestComments(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/request/comment", { query: this.normalizeParams(query) }));
    }

    getSingleSupportRequestComment(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/request/comment/${id}`));
    }

    createSupportTicketComment(payload: NoseurObject<any>): Promise<any> {
        return this.report(this.transport.post(`/hera/api/v1/support/request/comment`, payload));
    }

}
